import type { RecommendedQuestion } from '../sdk';

/** Questions Updated Alert Panel ID */
const questionsUpdatedId = 'alert-questions-updated';

/** Question */
const questionPanelId = (question: RecommendedQuestion): string => question.id;

export { questionsUpdatedId, questionPanelId };
